import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	today: {
		id: 'business-timeline.timeline-view.toolbar.today-button.today',
		defaultMessage: 'Today',
		description: "Button label. Scrolls the timeline to today's date",
	},
});
